import React from "react";
import { Link } from "react-router-dom";
import { SchlussBlock } from "@/components/SchlussBlock";

// 2g: vier Teile als vier Absätze ohne Überschriften; nur Teil 2 (wörtliche Rede) ist hervorgehoben.
export const KernAntwort = ({ antwort, typLabel }) => (
  <div className="space-y-4" data-testid="kern-antwort">
    {typLabel && (
      <p className="text-xs font-bold uppercase tracking-widest text-[#4563BB]" data-testid="kern-antwort-typ">
        Fokus deines Gegenübers: {typLabel}
      </p>
    )}
    <p className="text-base leading-relaxed text-slate-900" data-testid="kern-antwort-mechanismus">{antwort.mechanismus}</p>
    <p className="rounded-xl border-l-4 border-[#F3651D] bg-orange-50 p-4 text-lg font-semibold leading-snug text-slate-900" data-testid="kern-antwort-satz">
      {antwort.satz}
    </p>
    <p className="text-base leading-relaxed text-slate-900" data-testid="kern-antwort-richtung">{antwort.richtung}</p>
    <p className="text-base leading-relaxed text-slate-900" data-testid="kern-antwort-planb">{antwort.plan_b}</p>
    {antwort.schluss && <SchlussBlock schluss={antwort.schluss} />}
    {antwort.tuer && (
      <p className="border-t border-slate-200 pt-4 text-sm leading-relaxed text-slate-600" data-testid="kern-antwort-tuer">{antwort.tuer}</p>
    )}
    {antwort.tuer_cta && (
      <Link to={antwort.tuer_cta.ziel} className="flex min-h-[52px] items-center justify-center rounded-2xl bg-slate-900 px-6 font-bold text-white" data-testid="kern-antwort-tuer-cta">
        {antwort.tuer_cta.text}
      </Link>
    )}
  </div>
);

export default KernAntwort;
